"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const messageCardsStyles_1 = __importDefault(require("./messageCardsStyles"));
const styles_1 = __importDefault(require("../../styles/styles"));
const text_1 = __importStar(require("../text/text"));
const primaryButton_1 = __importDefault(require("../primaryButton/primaryButton"));
const textStyles_1 = __importDefault(require("../text/textStyles"));
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const touchableElement_1 = __importDefault(require("../pressables/touchableElement"));
const colors_1 = __importDefault(require("../../styles/colors"));
const openExternalLink_1 = __importDefault(require("../openExternalLink/openExternalLink"));
const screenConstants_1 = require("../../constants/screenConstants");
const MessageCard = ({ warning, onPress, isInformation, isCustomUrl }) => {
    const navigation = (0, useAppNavigation_1.default)();
    let missingFields = [];
    let buttonCustomUrl = '';
    if (warning.missing_docs) {
        missingFields = missingFields.concat(warning.missing_docs);
    }
    if (warning.missing_data) {
        missingFields = missingFields.concat(warning.missing_data);
    }
    if (warning.button_url) {
        buttonCustomUrl = warning.button_url[0];
    }
    return (react_1.default.createElement(react_native_1.View, { style: [
            messageCardsStyles_1.default.card,
            styles_1.default.minimumMarginBetweenElementsVertically,
            isInformation ? messageCardsStyles_1.default.cardWhiteBackground : messageCardsStyles_1.default.cardRedBackground,
        ] },
        react_1.default.createElement(touchableElement_1.default, { onPress: onPress || (() => { }), eventName: "warning_card", style: [styles_1.default.flexDirectionRow, styles_1.default.mainContainerPadding] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexThree, styles_1.default.flexDirectionColumn] },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
                        warning.headline && (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, biggerSubtitle: true, style: textStyles_1.default.bold, color: isInformation ? undefined : colors_1.default.COLOR_BRICK_RED_5 }, warning.headline)),
                        warning.message && (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_GRAY_DARK }, warning.message)),
                        react_1.default.createElement(react_native_1.View, null,
                            missingFields.map((missingField) => (react_1.default.createElement(primaryButton_1.default, { key: missingField.screen, title: missingField.button, eventName: `navigate_to_${missingField.screen}`, onPress: missingField.onPress
                                    ? missingField.onPress
                                    : () => navigation.navigate(missingField.screen, missingField.params), color: isInformation ? undefined : colors_1.default.COLOR_WHITE, textColor: isInformation ? undefined : colors_1.default.COLOR_BLACK }))),
                            isCustomUrl && (react_1.default.createElement(primaryButton_1.default, { title: warning.button_text ? warning.button_text : '', eventName: "warning_display_webview", onPress: () => (0, openExternalLink_1.default)({
                                    navigation,
                                    url: buttonCustomUrl,
                                    webViewData: {
                                        sourcePage: screenConstants_1.HOME_SCREEN,
                                        sourceScreen: 'Home',
                                        name: 'Remita Mandate',
                                        title: 'Remita Mandate',
                                    },
                                }), color: colors_1.default.COLOR_WHITE, textColor: colors_1.default.COLOR_BLACK })))))))));
};
// MessageCard.defaultProps = {
//     isInformation: false,
//     onPress: undefined,
// };
exports.default = MessageCard;
